import { render, staticRenderFns } from "./PromoteAnnualInsight.vue?vue&type=template&id=bb333bb0&scoped=true"
import script from "./PromoteAnnualInsight.vue?vue&type=script&lang=js"
export * from "./PromoteAnnualInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb333bb0",
  null
  
)

export default component.exports